// @noflow
import React from 'react'
import { useTranslation } from 'react-i18next'

// Components
import Image from '@/components/elements/atoms/Image/Image'
import { SectionWrapper } from '@/components/elements/atoms/SectionWrapper'
import Text from '@/components/elements/atoms/Text/Text'
import ModalLayout from '@/components/modals/layout'

import { WhereToStartFragment as Dog } from './fragments/__generated__/WhereToStartFragment'

type Props = {
  data: {
    dogs: Array<Dog>
  }
}

const WhereToStart = ({ data: { dogs } }: Props): JSX.Element => {
  const { t } = useTranslation('modals')
  const dog = dogs[0]
  const { name: dogName, caloriesFedByPlan, gender, possessivePronoun } = dog
  const context = dogs.length > 1 ? 'plural' : gender

  const commonTextProps = {
    namespace: 'modals',
    margin: false
  }

  return (
    <ModalLayout title={{ text: 'where_to_start.title', namespace: 'modals' }}>
      <SectionWrapper margin={{ top: 16, bottom: 0 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
          <Image
            alt={t('where_to_start.img_alt.full')}
            image={{
              width: 56,
              height: 54,
              resizeMode: 'resize_to_fill',
              retina: true
            }}
            slug={'allin-butternut'}
          />
          <div>
            <Text
              text={`where_to_start.change_amount.title`}
              variant="display20"
              variables={{ dogName }}
              {...commonTextProps}
            />
            <Text
              text="where_to_start.change_amount.description"
              variables={{ dogName, context }}
              namespace="modals"
              margin={false}
            />
          </div>
        </div>
      </SectionWrapper>
      <SectionWrapper margin={{ top: 32, bottom: 0 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
          <Image
            alt={t('where_to_start.img_alt.half')}
            image={{
              width: 56,
              height: 54,
              resizeMode: 'resize_to_fill',
              retina: true
            }}
            slug={'plan-size-as-portions-half-butternut'}
          />
          <div>
            <Text
              text={`where_to_start.mix_feeding.title`}
              variant="display20"
              {...commonTextProps}
            />
            <Text
              text="where_to_start.mix_feeding.description"
              variables={{
                dogName,
                context,
                possessivePronoun,
                caloriesFedByPlan
              }}
              {...commonTextProps}
            />
          </div>
        </div>
      </SectionWrapper>
    </ModalLayout>
  )
}

export type { Props as WhereToStartProps }

export { WhereToStart }
